import { render, staticRenderFns } from "./Regulamento.vue?vue&type=template&id=4f9c7970&scoped=true&"
import script from "./Regulamento.vue?vue&type=script&lang=js&"
export * from "./Regulamento.vue?vue&type=script&lang=js&"
import style0 from "./Regulamento.vue?vue&type=style&index=0&id=4f9c7970&prod&lang=scss&scoped=true&"
import style1 from "./Regulamento.vue?vue&type=style&index=1&id=4f9c7970&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c7970",
  null
  
)

export default component.exports